<app-scelta-pde-struttura [idRichiesta]="1" (valueChanged)="nextStep()">
</app-scelta-pde-struttura>